import { render, staticRenderFns } from "./homePageAbout.vue?vue&type=template&id=71230145&"
import script from "./homePageAbout.vue?vue&type=script&lang=js&"
export * from "./homePageAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports